//@Flow
import BrandService from "../service/BrandService/BrandService";

export class BrandBloc {

    _brandService: BrandService;

    constructor(brandService: BrandService) {
        this._brandService = brandService;
    }

    async getBrand() {
        return await this._brandService.getBrand();
    }

    async createOrUpdateBrand(brand: Object, isUpdateRequest: boolean, logo: ?Object) {
        return await this._brandService.createOrUpdateBrand(brand, isUpdateRequest, logo);
    }
}
